import { Result } from '@/app/tracking/tracking-api'
import { StudentInfo } from '../api/student-info'

export type StudentInfoErrorCode = 'query-error'

export interface StudentInfoError {
  code: StudentInfoErrorCode;
  details: unknown;
}

export const StudentInfoDataStoreSymbol = Symbol.for('StudentInfoDataStore')
export interface StudentInfoDataStore {
  get(): Promise<Result<StudentInfo, StudentInfoError>>;
}
